import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useUnit } from 'effector-react';
import { Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { DeleteDialog } from '@shared/ui';
import {
  $selectRow,
  setAddRelation,
  startRelatedDelete,
} from '../../../models/related-tickets';
import * as Styled from '../styled';

export const Header = () => {
  const { t } = useTranslation();
  const [actionConfirmation, setActionConfirmation] = useState(false);
  const [selectRow] = useUnit([$selectRow]);

  return (
    <>
      <DeleteDialog
        title={t('ActionConfirmation')}
        content={t('DeleteLinkRelatedTicketAlert')}
        isOpen={actionConfirmation}
        onClose={() => setActionConfirmation(false)}
        onConfirm={() => {
          setActionConfirmation(false);
          startRelatedDelete();
        }}
      />

      <Styled.Header>
        <Button
          startIcon={<AddIcon />}
          variant="contained"
          onClick={() => setAddRelation(true)}
        >
          {t('AddRelation')}
        </Button>

        <Button
          startIcon={<DeleteOutlineIcon />}
          variant="outlined"
          onClick={() => setActionConfirmation(true)}
          disabled={!selectRow.length}
          color="error"
        >
          {t('RemoveLink')}
        </Button>
      </Styled.Header>
    </>
  );
};
